import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
@Component({
    selector: 'icon-youtube',
    template: `
            <svg [class]="class" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path stroke="currentColor" fill="none"
                      d="M23.498 6.186c-.276-1.034-1.092-1.85-2.126-2.126C19.48 3.52 12 3.52 12 3.52s-7.48 0-9.372.54c-1.034.276-1.85 1.092-2.126 2.126C.96 8.08.96 12 .96 12s0 3.92.542 5.814c.276 1.034 1.092 1.85 2.126 2.126C4.52 20.48 12 20.48 12 20.48s7.48 0 9.372-.54c1.034-.276 1.85-1.092 2.126-2.126.54-1.892.54-5.814.54-5.814s0-3.92-.54-5.814z"/>
                <path fill="#FFFFFF" d="M9.545 15.568V8.432L15.545 12z"/>
            </svg>
    `,
    standalone: true
})
export class IconYoutube {
    @Input() class: any = '';
}
